module.exports = __webpack_public_path__ + "17bbb88cd1bf654e25e971ea2158de95.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-21.png
// module id = 1791
// module chunks = 0